<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:<span v-if="required" class="text-red-500">*</span></label>
    <v-select
      class="v-select-style"
      :class="{ error: error }"
      v-model="selected"
      :getOptionLabel="getOptionLabel"
      :options="options"
      :placeholder="placeholder"
      :multiple="multiple"
      :searchable="searchable"
      :clearable="clearable"
    >
      <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
        <slot :key="slot" :name="slot" v-bind="scope" />
      </template>
      <template #no-options>
        <div class="text-xs">
          {{ text }}
        </div>
      </template>
    </v-select>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  inheritAttrs: false,
  components: {
    vSelect,
  },
  props: {
    url: String,
    id: {
      type: String,
      default() {
        return `vue-select-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    required: String,
    getOptionLabel: {
      type: Function,
      default: (item) => item.name,
    },
    text: String,
    modelValue: Object,
    options: {
      type: Array,
      default: [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: this.modelValue,
    }
  },
  watch: {
    selected(selected) {
      this.$emit('update:modelValue', selected)
    },
    modelValue(modelValue) {
      this.selected = modelValue;
    },
  },
}
</script>
<style>
.v-select-style .vs__dropdown-toggle {
  @apply appearance-none bg-white border-solid rounded-md border-gray-200;
  padding: 5px 0px 5px 0px;
}
.v-select-style.vs--open .vs__dropdown-toggle {
  border-color: var(--color-primary);
}
.v-select-style .vs__dropdown-menu {
  @apply appearance-none rounded-none scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-200;
}
.v-select-style .vs__selected {
  @apply leading-normal text-gray-700 whitespace-nowrap;
}
.v-select-style .vs__selected-options {
  @apply overflow-x-auto flex-nowrap scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-200;
}
.v-select-style.error .vs__dropdown-toggle {
  @apply border-red-500;
}
</style>